import {
  type QueryFilters,
  type QueryKey,
  useIsFetching as useIsFetchingRQ,
  useQueryClient,
} from '@tanstack/react-query';

export const useInvalidateQuery = () => {
  const queryClient = useQueryClient();

  return {
    invalidate: async (
      queryKey: QueryKey,
      refetchType: QueryFilters['type'] = 'active',
    ) => {
      await queryClient.invalidateQueries({ queryKey, refetchType });
    },
  };
};

export const useRemoveQueries = () => {
  const queryClient = useQueryClient();
  return {
    removeQuery: (queryKey: QueryKey) => {
      queryClient.removeQueries({ queryKey, exact: true });
    },
    removeQueries: () => {
      queryClient.removeQueries();
    },
  };
};

export const useIsFetching = ({ queryKey }: QueryFilters = {}) => {
  const isFetching = useIsFetchingRQ({
    queryKey,
  });
  return isFetching > 0;
};
